'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LevelSettings = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _ToggleEntry = require('./ToggleEntry.js');

var _LogProvider = require('../Providers/LogProvider.js');

var _LevelSettings = require('./LevelSettings.less');

var _LevelSettings2 = _interopRequireDefault(_LevelSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LevelSettings = exports.LevelSettings = function (_Component) {
	_inherits(LevelSettings, _Component);

	function LevelSettings() {
		_classCallCheck(this, LevelSettings);

		return _possibleConstructorReturn(this, (LevelSettings.__proto__ || Object.getPrototypeOf(LevelSettings)).apply(this, arguments));
	}

	_createClass(LevelSettings, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return React.createElement(
				'div',
				{ className: _LevelSettings2.default.settings + ' popovermenu bubble open menu' },
				React.createElement(
					'h4',
					null,
					t('settings', 'Log levels')
				),
				_LogProvider.LogProvider.levels.map(function (name, level) {
					return React.createElement(
						_ToggleEntry.ToggleEntry,
						{ key: level,
							active: _this2.props.levels[level],
							onChange: _this2.props.setLevel.bind(_this2, level) },
						name
					);
				}),
				React.createElement(
					'h4',
					null,
					t('settings', 'Log content')
				),
				React.createElement(
					_ToggleEntry.ToggleEntry,
					{ active: this.props.live, onChange: this.props.setLive },
					t('settings', 'Live update')
				),
				React.createElement(
					'a',
					{ href: OC.generateUrl('settings/admin/log/download'),
						className: 'button' },
					t('settings', 'Download logs')
				)
			);
		}
	}]);

	return LevelSettings;
}(_react.Component);


//////////////////
// WEBPACK FOOTER
// ./js/Components/LevelSettings.js
// module id = 652
// module chunks = 0